<template>
  <div class="app-content-wrapper">
    <div v-loading="isLoading">
      <div v-if="listInfo.content.length > 0" class="list-wrapper">
        <div
          v-for="item in listInfo.content"
          :key="item.id"
          class="notice-item"
          @click="handleNoticeItem(item.id)"
        >
          <div class="notice-item-title">
            <span class="item-title-txt">{{item.title}}</span>
            <el-tag type="success">{{$t('message.notice.notice')}}</el-tag>
          </div>
          <div class="notice-item-content">{{item.content}}</div>
          <div class="notice-item-time">{{item.createTime}}</div>
          <span class="icon-arrow iconfont icon-a-Link1"></span>
        </div>
        <div class="rhcn-pagination">
          <el-pagination
            v-if="listInfo.totalElements && listInfo.totalElements != 0"
            background
            :page-sizes="[10, 20, 50]"
            :current-page="Number(listInfo.current)"
            :page-size="listInfo.size"
            :total="listInfo.totalElements"
            layout="total, sizes, prev, pager,jumper,next"
            :prev-text="$t('message.tableTitleCommon.previous')"
            :next-text="$t('message.tableTitleCommon.next')"
            @current-change="onCurrentPageChange"
            @size-change="onPageSizeChange"
          />
        </div>
      </div>
      <div
        v-if="!isLoading && listInfo.content.length === 0"
        class="notice-empty-box"
      >
        <empty-component
          :empty-subtitle="$t('message.tableCommon.searcnEmpty')"
        ></empty-component>
      </div>
    </div>
  </div>
</template>
<script>
import EmptyComponent from '@/components/table/empty-component.vue';
import NoticeService from '@/views/content/api/notice';

export default {
  components: {
    EmptyComponent,
  },
  data() {
    return {
      isLoading: true,
      listInfo: {
        totalElements: 0,
        size: 10,
        current: 1,
        content: [],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.fetchContactList();
    },
    async fetchContactList() {
      this.isLoading = true;
      try {
        const res = await NoticeService.queryList({
          current: this.listInfo.current,
          size: this.listInfo.size,
        });
        this.listInfo = res;
      } catch (err) {
        //
      }
      this.isLoading = false;
    },
    onCurrentPageChange(index) {
      this.listInfo.current = index;
      this.fetchContactList();
    },
    onPageSizeChange(size) {
      this.listInfo.size = size;
      this.listInfo.current = 1;
      this.fetchContactList();
    },
    handleNoticeItem(id) {
      this.$router.push({ path: '/content/notice/detail', query: { id } });
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/pagination.scss";
</style>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
.list-wrapper {
  .notice-item {
    height: 100px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 17px;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;

    &:hover, &:active {
      background-color: #F4F6F8;
    }

    .notice-item-title {
      width: 46%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .item-title-txt {
        margin-right: 20px;
        font-size: 14px;
        font-family: AvenirNext-DemiBold, AvenirNext;
        font-weight: 600;
        color: $color-text-primary;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .notice-item-content {
      width: 80%;
      font-size: 14px;
      font-family: AvenirNext-Regular, AvenirNext;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 20px;
      margin-bottom: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .notice-item-time {
      font-size: 14px;
      font-family: AvenirNext-Regular, AvenirNext;
      font-weight: 400;
      color: rgba(38,67,115,0.3);
      line-height: 20px;
    }

    .icon-arrow {
      position: absolute;
      top: 50%;
      right: 26px;
      transform: translateY(-50%);
      color: $color-text-default-button;
      font-size: 12px;
    }
  }
}

.notice-empty-box {
  margin-top: 80px;
}
</style>
